module.exports = __webpack_public_path__ + "static/media/Kub_main.0dd4cfb9.jpg";